import { ITicket } from './../ticket';
import { IFlight } from './../../flights/flight';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TicketService } from '../ticket.service';

@Component({
  selector: 'app-change-flight',
  templateUrl: './change-flight.component.html',
  styleUrls: ['./change-flight.component.css']
})
export class ChangeFlightComponent implements OnInit {
  ticket: ITicket;
  changedFlight: IFlight;
  disableForm = true;
  constructor(
    private activeModal: NgbActiveModal,
    private ticketService: TicketService
  ) {}

  get flight() {
    return this.ticket.ticketFlight;
  }

  ngOnInit() {}

  closeActiveModal() {
    this.activeModal.dismiss();
  }

  initTicket(ticket: ITicket) {
    this.ticket = ticket;
    this.disableForm = false;
  }

  onChooseFlight(e: IFlight) {
    this.changedFlight = e;
  }

  saveTicket() {
    this.disableForm = true;
    const data = {
      id: this.ticket.id,
      ticketFlight: '/flights/' + this.changedFlight.id
    };

    this.ticketService.updateTicket(data).subscribe(
      res => {
        this.activeModal.close(res);
      },
      error => {
        alert(error.detail);
        this.disableForm = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/tickets/change-flight/change-flight.component.ts